export const SOURCE_TYPES = {
  OFFER: 'offer',
  SEARCH: 'search',
  METASEARCH: 'metasearch',
  CHECKOUT: 'checkout',
  CHANGE_DATES: 'changeDates',
  INIT_CHECKOUT: 'initCheckout',
  TOUR_TILE: 'tourTile',
  INIT_MOBILE_FLIGHT_CHECKOUT: 'initMobileFlightCheckout',
  CTA: 'cta',
  LOGGEDIN_METASEARCH: 'loggedInMetasearch',
} as const
